__turbopack_context__.v({
  "pbs_app_search_row": "PBSAppSearchRow-module-scss-module__zT6YsG__pbs_app_search_row",
  "pbs_app_search_row__content": "PBSAppSearchRow-module-scss-module__zT6YsG__pbs_app_search_row__content",
  "pbs_app_search_row__description": "PBSAppSearchRow-module-scss-module__zT6YsG__pbs_app_search_row__description",
  "pbs_app_search_row__devices_image": "PBSAppSearchRow-module-scss-module__zT6YsG__pbs_app_search_row__devices_image",
  "pbs_app_search_row__devices_image_link": "PBSAppSearchRow-module-scss-module__zT6YsG__pbs_app_search_row__devices_image_link",
  "pbs_app_search_row__title": "PBSAppSearchRow-module-scss-module__zT6YsG__pbs_app_search_row__title",
});
